export const translations = {
  lt: {
    nav: {
      home: "Pradžia",
      about: "Apie projektą",
      migdolas: "Migdolas",
      vysnia: "Vyšnia",
      location: "Vieta",
      gallery: "Galerija",
      contact: "Kontaktai",
      adminLogin: "CRM",
    },
    common: {
      brand: "Sakurų namai",
      viewListing: "Peržiūrėti originalų skelbimą",
      learnMore: "Sužinoti daugiau",
      viewApartments: "Peržiūrėti butus",
      contactUs: "Susisiekite",
      apartments: "butai",
      apartment: "Butas",
      floor: "Aukštas",
      rooms: "Kambariai",
      area: "Plotas",
      price: "Kaina",
      orientation: "Orientacija",
      terrace: "Terasa / lodžija",
      terraceLabel: "Terasa",
      loggiaLabel: "Lodžija",
      available: "Laisvas",
      reserved: "Rezervuotas",
      sold: "Parduotas",
      from: "nuo",
      imageComingSoon: "Vaizdas netrukus",
      backTo: "Grįžti į",
      allRights: "Visos teisės saugomos.",
      energyClass: "Energinė klasė",
      total: "Iš viso",
      totalApartmentArea: "Bendra buto kvadratūra",
      windowOrientation: "Langų orientacija",
      terraceArea: "Terasos plotas",
      landPlotArea: "Žemės sklypo plotas",
      showMore: "Rodyti daugiau",
      showLess: "Slėpti",
      notApplicable: "Netaikoma",
    },
    home: {
      tagline: "Atraskite ramybės oazę Marijampolės širdyje!",
      intro:
        "Sakurų namai — du modernūs, A++ energinės klasės gyvenamieji namai prie Pašešupio parko ir Sakurų salos. Aukščiausios kokybės naujos statybos butai nuo 31 iki 92 m², 1–4 kambarių išplanavimai.",
      ctaMigdolas: "Migdolas — 20 butų",
      ctaVysnia: "Vyšnia — 25 butai",
      sellingPointsTitle: "Kodėl Sakurų namai?",
      exploreProject: "Susipažinkite su projektu",
    },
    sellingPoints: [
      "Naujos statybos A++ energinės klasės butai — aukštas komfortas, mažesnės eksploatacijos išlaidos",
      "Aukštos kokybės, natūralios, ilgaamžės medžiagos",
      "Prestižinė, saugi vieta gamtos apsuptyje, šalia renovuoto Pašešupio parko ir Šešupės upės; dalis butų su tvenkinio vaizdu",
      "Platus butų pasirinkimas su erdviomis terasomis / lodžijomis",
      "Vidinis kiemas su poilsio, sporto ir vaikų žaidimų zonomis",
      "Saugoma automobilių stovėjimo aikštelė šalia namų",
    ],
    about: {
      title: "Apie projektą",
      subtitle: "Prestižinis gyvenimas gamtos apsuptyje",
      description1:
        "Sakurų namai — tai išskirtinis gyvenamasis kvartalas Marijampolės širdyje, įsikūręs prie Pašešupio parko ir žymiosios Sakurų salos. Projektą sukūrė apdovanojimų pelnęs architektas G. Vieversys, derindamas modernią architektūrą su natūralia aplinka.",
      description2:
        "Kvartalą sudaro du modernūs A++ energinės klasės gyvenamieji namai — Migdolas ir Vyšnia. Butai pasižymi aukšta kokybe, natūraliomis medžiagomis ir apgalvotu išplanavimu.",
      architectTitle: "Architektas",
      architectName: "G. Vieversys",
      architectDesc: "Apdovanojimus pelnęs architektas",
      buildingsTitle: "Du gyvenamieji namai",
      migdolasDesc: "20 butų • 5 aukštai • 4 butai aukšte",
      vysniaDesc: "25 butai • 5 aukštai • 5 butai aukšte",
      amenitiesTitle: "Vidinis kiemas ir infrastruktūra",
    },
    building: {
      migdolasTitle: "Migdolas",
      vysniaTitle: "Vyšnia",
      migdolasSub: "20 butų • 5 aukštai • 4 butai kiekviename aukšte • A++",
      vysniaSub: "25 butai • 5 aukštai • 5 butai kiekviename aukšte • A++",
      floorPlans: "Aukštų planai",
      floorLabel: "aukštas",
      apartmentTable: "Butų sąrašas",
      viewApartment: "Peržiūrėti",
      selectFloor: "Pasirinkite aukštą",
      allFloors: "Visi aukštai",
      viewDetails: "Plačiau",
      filterStatus: "Būsena",
      filterRooms: "Kambariai",
      allStatuses: "Visos būsenos",
      allRooms: "Visi",
      detailsTitle: "Buto informacija",
    },
    apartment: {
      backToBuilding: "Grįžti į pastatą",
      totalArea: "Bendras plotas",
      totalApartmentArea: "Bendras buto plotas",
      totalWithLoggia: "Bendras buto plotas su lodžija",
      landShare: "Nuosava žemės dalis",
      floorOf: "aukštas iš",
      priceIncrease: "Kaina neseniai padidėjo ~{x}%",
      breakdown: "Patalpų plotai",
      features: "Būsto ypatybės",
      inquire: "Domina šis butas",
      floorPlanSheet: "Buto planas",
    },
    location: {
      title: "Vieta",
      subtitle: "Parko g. 1D, Marijampolė",
      intro:
        "Sakurų namai įsikūrę ramioje, žalioje Degučių seniūnijoje, vos per kelias minutes nuo miesto centro. Aplink — parkai, mokyklos, parduotuvės ir visa reikalinga infrastruktūra.",
      amenitiesTitle: "Netoliese",
      shops: "Parduotuvės",
      shopsDetail: "Norfa, Aibė, Maxima",
      schools: "Mokyklos",
      kindergartens: "Darželiai",
      universities: "Universitetai / kolegijos",
      sports: "Sporto klubai",
      medical: "Medicinos įstaigos",
      pharmacies: "Vaistinės",
      surroundingsTitle: "Vieta ir aplinka",
      parkTitle: "Pašešupio parkas",
      parkText: "Beveik 28 hektarų parkas palei Šešupės upę, neseniai atnaujintas: 3 km dendrologinis takas, sporto ir vaikų žaidimų aikštelės, maudymosi zona bei poilsio erdvės — vos kelios minutės pėsčiomis nuo projekto.",
      articlesTitle: "Susiję straipsniai",
      readArticle: "Skaityti straipsnį",
    },
    gallery: {
      title: "Galerija",
      subtitle: "Realios vizualizacijos ir vaizdai",
      empty: "Nuotraukų kol kas nėra.",
    },
    spec: {
      moreTitle: "Daugiau apie butą",
      generalInfo: "Bendra informacija",
      features: "Ypatybės",
      additionalSpaces: "Papildomos erdvės",
      additionalEquipment: "Papildoma įranga",
      security: "Sauga",
      rooms: "Kambarių skaičius",
      area: "Plotas",
      terraceArea: "Terasos plotas",
      totalArea: "Bendras plotas",
      apartmentArea: "Buto plotas",
      loggiaArea: "Lodžijos plotas",
      floor: "Aukštas",
      totalFloors: "Aukštų skaičius pastate",
      yearBuilt: "Statybos metai",
      finishing: "Apdaila",
      orientation: "Langų orientacija",
      buildingType: "Pastato tipas",
      heating: "Šildymas",
      energyClass: "Energinė klasė",
      elevator: "Liftas",
      separateEntrance: "Atskiras įėjimas",
      highCeilings: "Aukštos lubos",
      newSewage: "Nauja kanalizacija",
      newWiring: "Nauja elektros instaliacija",
      enclosedYard: "Aptvertas kiemas",
      internet: "Internetas",
      kitchenLiving: "Virtuvė sujungta su svetaine",
      terrace: "Terasa",
      loggia: "Lodžija",
      airConditioning: "Oro kondicionierius",
      underfloorHeating: "Grindinis šildymas",
      plasticPipes: "Plastikiniai vamzdžiai",
      heatRecovery: "Rekuperacinė sistema",
      armoredDoor: "Šarvuotos durys",
      alarm: "Signalizacija",
      codedLock: "Kodinė laukujė spyna",
      cctv: "Vaizdo kameros",
      val_partial: "Dalinė apdaila",
      val_block: "Blokinis / skydinis",
      val_centralElectric: "Centrinis, elektrinis",
      dir_north: "Šiaurė", dir_south: "Pietūs", dir_east: "Rytai", dir_west: "Vakarai", dir_southwest: "Pietvakariai", dir_northwest: "Šiaurės vakarai", dir_northeast: "Šiaurės rytai", dir_southeast: "Pietryčiai",
    },
    contact: {
      title: "Kontaktai",
      subtitle: "Susisiekite su mumis dėl butų pardavimo",
      name: "Vardas",
      email: "El. paštas",
      phone: "Telefonas",
      building: "Pastatas",
      apartmentSelect: "Butas (nebūtina)",
      message: "Žinutė",
      selectBuilding: "Pasirinkite pastatą",
      none: "Nenurodyta",
      send: "Siųsti užklausą",
      sending: "Siunčiama...",
      success: "Ačiū! Jūsų užklausa gauta. Susisieksime su Jumis.",
      error: "Įvyko klaida. Bandykite dar kartą arba skambinkite.",
      callUs: "Skambinkite",
      emailUs: "Rašykite",
      addressLabel: "Adresas",
      whatsappCta: "Rašyti per WhatsApp",
    },
    finance: {
      title: "Finansavimo pavyzdys",
      subtitle: "Iliustracinis būsto paskolos skaičiuoklė",
      propertyPrice: "Buto kaina",
      downPayment: "Pradinis įnašas",
      loanTerm: "Paskolos terminas",
      interestRate: "Palūkanų norma",
      years: "metai",
      monthlyPayment: "Mėnesinė įmoka",
      loanAmount: "Paskolos suma",
      disclaimer:
        "* Tai tik iliustracinis pavyzdys, o ne įpareigojantis pasiūlymas. Tikslias sąlygas nustato bankas pagal individualų vertinimą.",
    },
    admin: {
      loginTitle: "CRM Prisijungimas",
      loginSub: "Sakurų namai valdymo sistema",
      username: "Prisijungimo vardas",
      password: "Slaptažodis",
      login: "Prisijungti",
      loggingIn: "Jungiamasi...",
      logout: "Atsijungti",
      dashboard: "Skydelis",
      leads: "Užklausos",
      inventory: "Butų būklė",
      totalLeads: "Iš viso užklausų",
      newLeads: "Naujos užklausos",
      soldUnits: "Parduoti butai",
      availableUnits: "Laisvi butai",
      reservedUnits: "Rezervuoti",
      searchPlaceholder: "Ieškoti pagal vardą, el. paštą, telefoną...",
      filterBuilding: "Pastatas",
      filterStatus: "Būsena",
      all: "Visi",
      date: "Data",
      name: "Vardas",
      contact: "Kontaktai",
      buildingCol: "Pastatas / Butas",
      status: "Būsena",
      source: "Šaltinis",
      actions: "Veiksmai",
      view: "Peržiūrėti",
      noLeads: "Užklausų nėra",
      leadDetail: "Užklausos informacija",
      notes: "Vidinės pastabos",
      addNote: "Pridėti pastabą",
      notePlaceholder: "Įrašykite pastabą (skambučio santrauka, priminimas)...",
      save: "Išsaugoti",
      message: "Žinutė",
      receivedAt: "Gauta",
      updateStatus: "Keisti būseną",
      inventoryTitle: "Butų prieinamumas",
      markAs: "Pažymėti kaip",
    },
    statuses: {
      New: "Nauja",
      Contacted: "Susisiekta",
      "Viewing Scheduled": "Suplanuota apžiūra",
      Negotiating: "Deramasi",
      Sold: "Parduota",
      Lost: "Prarasta",
    },
  },

  en: {
    nav: {
      home: "Home",
      about: "About",
      migdolas: "Migdolas",
      vysnia: "Vyšnia",
      location: "Location",
      gallery: "Gallery",
      contact: "Contact",
      adminLogin: "CRM",
    },
    common: {
      brand: "Sakurų namai",
      viewListing: "See original listing",
      learnMore: "Learn more",
      viewApartments: "View apartments",
      contactUs: "Contact us",
      apartments: "apartments",
      apartment: "Apartment",
      floor: "Floor",
      rooms: "Rooms",
      area: "Area",
      price: "Price",
      orientation: "Orientation",
      terrace: "Terrace / loggia",
      terraceLabel: "Terrace",
      loggiaLabel: "Loggia",
      available: "Available",
      reserved: "Reserved",
      sold: "Sold",
      from: "from",
      imageComingSoon: "Image coming soon",
      backTo: "Back to",
      allRights: "All rights reserved.",
      energyClass: "Energy class",
      total: "Total",
      totalApartmentArea: "Total apartment area",
      windowOrientation: "Window orientation",
      terraceArea: "Terrace area",
      landPlotArea: "Land plot area",
      showMore: "Show more",
      showLess: "Show less",
      notApplicable: "Not applicable",
    },
    home: {
      tagline: "Discover an oasis of peace in the heart of Marijampolė.",
      intro:
        "Sakurų namai — two modern, A++ energy class residential buildings next to Pašešupis park and Sakura Island. Premium new-build apartments from 31 to 92 m², with 1–4 room layouts.",
      ctaMigdolas: "Migdolas — 20 apartments",
      ctaVysnia: "Vyšnia — 25 apartments",
      sellingPointsTitle: "Why Sakurų namai?",
      exploreProject: "Explore the project",
    },
    sellingPoints: [
      "New-build A++ energy class apartments — high comfort, lower running costs",
      "High-quality, natural, durable materials",
      "Prestigious, safe location surrounded by nature, next to the renovated Pašešupis park and the Šešupė river; some apartments have a pond view",
      "Wide choice of apartments with spacious terraces / loggias",
      "Inner courtyard with relaxation, sports, and play areas for children",
      "Guarded parking area next to the buildings",
    ],
    about: {
      title: "About the Project",
      subtitle: "Prestigious living surrounded by nature",
      description1:
        "Sakurų namai is an exceptional residential quarter in the heart of Marijampolė, located next to Pašešupis park and the famous Sakura Island. Designed by award-winning architect G. Vieversys, blending modern architecture with the natural surroundings.",
      description2:
        "The quarter consists of two modern A++ energy class residential buildings — Migdolas and Vyšnia. The apartments feature high quality, natural materials and thoughtful layouts.",
      architectTitle: "Architect",
      architectName: "G. Vieversys",
      architectDesc: "Award-winning architect",
      buildingsTitle: "Two residential buildings",
      migdolasDesc: "20 apartments • 5 floors • 4 per floor",
      vysniaDesc: "25 apartments • 5 floors • 5 per floor",
      amenitiesTitle: "Inner courtyard & amenities",
    },
    building: {
      migdolasTitle: "Migdolas",
      vysniaTitle: "Vyšnia",
      migdolasSub: "20 apartments • 5 floors • 4 per floor • A++",
      vysniaSub: "25 apartments • 5 floors • 5 per floor • A++",
      floorPlans: "Floor plans",
      floorLabel: "floor",
      apartmentTable: "Apartment list",
      viewApartment: "View",
      selectFloor: "Select floor",
      allFloors: "All floors",
      viewDetails: "View Details",
      filterStatus: "Status",
      filterRooms: "Rooms",
      allStatuses: "All statuses",
      allRooms: "All",
      detailsTitle: "Apartment details",
    },
    apartment: {
      backToBuilding: "Back to building",
      totalArea: "Total area",
      totalApartmentArea: "Total apartment area",
      totalWithLoggia: "Total area with loggia",
      landShare: "Private land share",
      floorOf: "floor of",
      priceIncrease: "Price recently increased ~{x}%",
      breakdown: "Room areas",
      features: "Property features",
      inquire: "Interested in this apartment",
      floorPlanSheet: "Apartment floor plan",
    },
    location: {
      title: "Location",
      subtitle: "Parko g. 1D, Marijampolė",
      intro:
        "Sakurų namai is located in the quiet, green Degučiai district, just minutes from the city centre. Surrounded by parks, schools, shops and all necessary infrastructure.",
      amenitiesTitle: "Nearby",
      shops: "Shops",
      shopsDetail: "Norfa, Aibė, Maxima",
      schools: "Schools",
      kindergartens: "Kindergartens",
      universities: "Universities / colleges",
      sports: "Sports clubs",
      medical: "Medical facilities",
      pharmacies: "Pharmacies",
      surroundingsTitle: "Location & Surroundings",
      parkTitle: "Pašešupis Park",
      parkText: "A nearly 28-hectare park along the Šešupė river, recently renovated: a 3 km dendrological trail, sports and children's playgrounds, a swimming area and rest zones — just a few minutes' walk from the project.",
      articlesTitle: "Related articles",
      readArticle: "Read article",
    },
    gallery: {
      title: "Gallery",
      subtitle: "Real renders and site views",
      empty: "No photos yet.",
    },
    spec: {
      moreTitle: "More about the apartment",
      generalInfo: "General info",
      features: "Features",
      additionalSpaces: "Additional spaces",
      additionalEquipment: "Additional equipment",
      security: "Security",
      rooms: "Number of rooms",
      area: "Area",
      terraceArea: "Terrace area",
      totalArea: "Total area",
      apartmentArea: "Apartment area",
      loggiaArea: "Loggia area",
      floor: "Floor",
      totalFloors: "Total floors in building",
      yearBuilt: "Year built",
      finishing: "Finishing",
      orientation: "Window orientation",
      buildingType: "Building type",
      heating: "Heating",
      energyClass: "Energy class",
      elevator: "Elevator",
      separateEntrance: "Separate entrance",
      highCeilings: "High ceilings",
      newSewage: "New sewage system",
      newWiring: "New electrical wiring",
      enclosedYard: "Enclosed yard",
      internet: "Internet",
      kitchenLiving: "Kitchen combined with living room",
      terrace: "Terrace",
      loggia: "Loggia",
      airConditioning: "Air conditioning",
      underfloorHeating: "Underfloor heating",
      plasticPipes: "Plastic pipes",
      heatRecovery: "Heat recovery / ventilation system",
      armoredDoor: "Armored door",
      alarm: "Alarm system",
      codedLock: "Coded entrance lock",
      cctv: "CCTV cameras",
      val_partial: "Partial finishing",
      val_block: "Block / panel",
      val_centralElectric: "Central, electric",
      dir_north: "North", dir_south: "South", dir_east: "East", dir_west: "West", dir_southwest: "Southwest", dir_northwest: "Northwest", dir_northeast: "Northeast", dir_southeast: "Southeast",
    },
    contact: {
      title: "Contact",
      subtitle: "Get in touch about apartment sales",
      name: "Name",
      email: "Email",
      phone: "Phone",
      building: "Building",
      apartmentSelect: "Apartment (optional)",
      message: "Message",
      selectBuilding: "Select building",
      none: "Not specified",
      send: "Send inquiry",
      sending: "Sending...",
      success: "Thank you! Your inquiry has been received. We'll be in touch.",
      error: "An error occurred. Please try again or call us.",
      callUs: "Call us",
      emailUs: "Email us",
      addressLabel: "Address",
      whatsappCta: "Message on WhatsApp",
    },
    finance: {
      title: "Financing Example",
      subtitle: "Illustrative mortgage calculator",
      propertyPrice: "Apartment price",
      downPayment: "Down payment",
      loanTerm: "Loan term",
      interestRate: "Interest rate",
      years: "years",
      monthlyPayment: "Monthly payment",
      loanAmount: "Loan amount",
      disclaimer:
        "* This is an illustrative example only, not a binding offer. Exact terms are set by the bank based on individual assessment.",
    },
    admin: {
      loginTitle: "CRM Login",
      loginSub: "Sakurų namai management system",
      username: "Username",
      password: "Password",
      login: "Log in",
      loggingIn: "Logging in...",
      logout: "Log out",
      dashboard: "Dashboard",
      leads: "Leads",
      inventory: "Inventory",
      totalLeads: "Total leads",
      newLeads: "New leads",
      soldUnits: "Sold units",
      availableUnits: "Available units",
      reservedUnits: "Reserved",
      searchPlaceholder: "Search by name, email, phone...",
      filterBuilding: "Building",
      filterStatus: "Status",
      all: "All",
      date: "Date",
      name: "Name",
      contact: "Contact",
      buildingCol: "Building / Apt",
      status: "Status",
      source: "Source",
      actions: "Actions",
      view: "View",
      noLeads: "No leads yet",
      leadDetail: "Lead details",
      notes: "Internal notes",
      addNote: "Add note",
      notePlaceholder: "Write a note (call summary, follow-up reminder)...",
      save: "Save",
      message: "Message",
      receivedAt: "Received",
      updateStatus: "Update status",
      inventoryTitle: "Apartment availability",
      markAs: "Mark as",
    },
    statuses: {
      New: "New",
      Contacted: "Contacted",
      "Viewing Scheduled": "Viewing Scheduled",
      Negotiating: "Negotiating",
      Sold: "Sold",
      Lost: "Lost",
    },
  },

  ru: {
    nav: {
      home: "Главная",
      about: "О проекте",
      migdolas: "Migdolas",
      vysnia: "Vyšnia",
      location: "Расположение",
      gallery: "Галерея",
      contact: "Контакты",
      adminLogin: "CRM",
    },
    common: {
      brand: "Sakurų namai",
      viewListing: "Смотреть оригинальное объявление",
      learnMore: "Узнать больше",
      viewApartments: "Смотреть квартиры",
      contactUs: "Связаться",
      apartments: "квартиры",
      apartment: "Квартира",
      floor: "Этаж",
      rooms: "Комнаты",
      area: "Площадь",
      price: "Цена",
      orientation: "Ориентация",
      terrace: "Терраса / лоджия",
      terraceLabel: "Терраса",
      loggiaLabel: "Лоджия",
      available: "Свободна",
      reserved: "Забронирована",
      sold: "Продана",
      from: "от",
      imageComingSoon: "Изображение скоро",
      backTo: "Назад к",
      allRights: "Все права защищены.",
      energyClass: "Класс энергоэффективности",
      total: "Всего",
      totalApartmentArea: "Общая площадь квартиры",
      windowOrientation: "Ориентация окон",
      terraceArea: "Площадь террасы",
      landPlotArea: "Площадь участка",
      showMore: "Показать больше",
      showLess: "Скрыть",
      notApplicable: "Не применимо",
    },
    home: {
      tagline: "Откройте оазис спокойствия в сердце Мариямполе!",
      intro:
        "Sakurų namai — два современных жилых дома класса энергоэффективности A++ рядом с парком Пашешупис и Сакурским островом. Премиальные квартиры новой постройки от 31 до 92 м², планировки от 1 до 4 комнат.",
      ctaMigdolas: "Migdolas — 20 квартир",
      ctaVysnia: "Vyšnia — 25 квартир",
      sellingPointsTitle: "Почему Sakurų namai?",
      exploreProject: "Познакомьтесь с проектом",
    },
    sellingPoints: [
      "Квартиры новой постройки класса A++ — высокий комфорт, меньшие эксплуатационные расходы",
      "Высококачественные, натуральные, долговечные материалы",
      "Престижное, безопасное место в окружении природы, рядом с обновлённым парком Пашешупис и рекой Шешупе; из части квартир открывается вид на пруд",
      "Широкий выбор квартир с просторными террасами / лоджиями",
      "Внутренний двор с зонами отдыха, спорта и детскими площадками",
      "Охраняемая парковка рядом с домами",
    ],
    about: {
      title: "О проекте",
      subtitle: "Престижная жизнь в окружении природы",
      description1:
        "Sakurų namai — это исключительный жилой квартал в сердце Мариямполе, расположенный рядом с парком Пашешупис и знаменитым Сакурским островом. Проект создан отмеченным наградами архитектором G. Vieversys, сочетающим современную архитектуру с природным окружением.",
      description2:
        "Квартал состоит из двух современных жилых домов класса A++ — Migdolas и Vyšnia. Квартиры отличаются высоким качеством, натуральными материалами и продуманной планировкой.",
      architectTitle: "Архитектор",
      architectName: "G. Vieversys",
      architectDesc: "Отмеченный наградами архитектор",
      buildingsTitle: "Два жилых дома",
      migdolasDesc: "20 квартир • 5 этажей • 4 на этаже",
      vysniaDesc: "25 квартир • 5 этажей • 5 на этаже",
      amenitiesTitle: "Внутренний двор и инфраструктура",
    },
    building: {
      migdolasTitle: "Migdolas",
      vysniaTitle: "Vyšnia",
      migdolasSub: "20 квартир • 5 этажей • 4 квартиры на каждом этаже • A++",
      vysniaSub: "25 квартир • 5 этажей • 5 квартир на каждом этаже • A++",
      floorPlans: "Планы этажей",
      floorLabel: "этаж",
      apartmentTable: "Список квартир",
      viewApartment: "Смотреть",
      selectFloor: "Выберите этаж",
      allFloors: "Все этажи",
      viewDetails: "Подробнее",
      filterStatus: "Статус",
      filterRooms: "Комнаты",
      allStatuses: "Все статусы",
      allRooms: "Все",
      detailsTitle: "Информация о квартире",
    },
    apartment: {
      backToBuilding: "Назад к дому",
      totalArea: "Общая площадь",
      totalApartmentArea: "Общая площадь квартиры",
      totalWithLoggia: "Общая площадь с лоджией",
      landShare: "Собственная доля земли",
      floorOf: "этаж из",
      priceIncrease: "Цена недавно выросла ~{x}%",
      breakdown: "Площади помещений",
      features: "Характеристики жилья",
      inquire: "Интересует эта квартира",
      floorPlanSheet: "План квартиры",
    },
    location: {
      title: "Расположение",
      subtitle: "Parko g. 1D, Marijampolė",
      intro:
        "Sakurų namai расположен в тихом зелёном районе Дегучяй, всего в нескольких минутах от центра города. Вокруг — парки, школы, магазины и вся необходимая инфраструктура.",
      amenitiesTitle: "Рядом",
      shops: "Магазины",
      shopsDetail: "Norfa, Aibė, Maxima",
      schools: "Школы",
      kindergartens: "Детские сады",
      universities: "Университеты / колледжи",
      sports: "Спортивные клубы",
      medical: "Медицинские учреждения",
      pharmacies: "Аптеки",
      surroundingsTitle: "Расположение и окрестности",
      parkTitle: "Парк Пашешупис",
      parkText: "Парк площадью почти 28 гектаров вдоль реки Шешупе, недавно обновлён: дендрологическая тропа 3 км, спортивные и детские площадки, зона для купания и зоны отдыха — всего в нескольких минутах ходьбы от проекта.",
      articlesTitle: "Связанные статьи",
      readArticle: "Читать статью",
    },
    gallery: {
      title: "Галерея",
      subtitle: "Реальные визуализации и виды",
      empty: "Фотографий пока нет.",
    },
    spec: {
      moreTitle: "Подробнее о квартире",
      generalInfo: "Общая информация",
      features: "Особенности",
      additionalSpaces: "Дополнительные помещения",
      additionalEquipment: "Дополнительное оборудование",
      security: "Безопасность",
      rooms: "Количество комнат",
      area: "Площадь",
      terraceArea: "Площадь террасы",
      totalArea: "Общая площадь",
      apartmentArea: "Площадь квартиры",
      loggiaArea: "Площадь лоджии",
      floor: "Этаж",
      totalFloors: "Этажей в доме",
      yearBuilt: "Год постройки",
      finishing: "Отделка",
      orientation: "Ориентация окон",
      buildingType: "Тип дома",
      heating: "Отопление",
      energyClass: "Класс энергоэффективности",
      elevator: "Лифт",
      separateEntrance: "Отдельный вход",
      highCeilings: "Высокие потолки",
      newSewage: "Новая канализация",
      newWiring: "Новая электропроводка",
      enclosedYard: "Огороженный двор",
      internet: "Интернет",
      kitchenLiving: "Кухня совмещена с гостиной",
      terrace: "Терраса",
      loggia: "Лоджия",
      airConditioning: "Кондиционер",
      underfloorHeating: "Тёплый пол",
      plasticPipes: "Пластиковые трубы",
      heatRecovery: "Система рекуперации / вентиляции",
      armoredDoor: "Бронированная дверь",
      alarm: "Сигнализация",
      codedLock: "Кодовый замок",
      cctv: "Видеокамеры",
      val_partial: "Частичная отделка",
      val_block: "Блочный / панельный",
      val_centralElectric: "Центральное, электрическое",
      dir_north: "Север", dir_south: "Юг", dir_east: "Восток", dir_west: "Запад", dir_southwest: "Юго-запад", dir_northwest: "Северо-запад", dir_northeast: "Северо-восток", dir_southeast: "Юго-восток",
    },
    contact: {
      title: "Контакты",
      subtitle: "Свяжитесь с нами по вопросам продажи квартир",
      name: "Имя",
      email: "Эл. почта",
      phone: "Телефон",
      building: "Дом",
      apartmentSelect: "Квартира (необязательно)",
      message: "Сообщение",
      selectBuilding: "Выберите дом",
      none: "Не указано",
      send: "Отправить запрос",
      sending: "Отправка...",
      success: "Спасибо! Ваш запрос получен. Мы свяжемся с вами.",
      error: "Произошла ошибка. Попробуйте ещё раз или позвоните нам.",
      callUs: "Позвоните",
      emailUs: "Напишите",
      addressLabel: "Адрес",
      whatsappCta: "Написать в WhatsApp",
    },
    finance: {
      title: "Пример финансирования",
      subtitle: "Иллюстративный ипотечный калькулятор",
      propertyPrice: "Цена квартиры",
      downPayment: "Первоначальный взнос",
      loanTerm: "Срок кредита",
      interestRate: "Процентная ставка",
      years: "лет",
      monthlyPayment: "Ежемесячный платёж",
      loanAmount: "Сумма кредита",
      disclaimer:
        "* Это лишь иллюстративный пример, а не обязывающее предложение. Точные условия определяет банк на основании индивидуальной оценки.",
    },
    admin: {
      loginTitle: "Вход в CRM",
      loginSub: "Система управления Sakurų namai",
      username: "Имя пользователя",
      password: "Пароль",
      login: "Войти",
      loggingIn: "Вход...",
      logout: "Выйти",
      dashboard: "Панель",
      leads: "Запросы",
      inventory: "Статус квартир",
      totalLeads: "Всего запросов",
      newLeads: "Новые запросы",
      soldUnits: "Проданные квартиры",
      availableUnits: "Свободные квартиры",
      reservedUnits: "Забронированы",
      searchPlaceholder: "Поиск по имени, эл. почте, телефону...",
      filterBuilding: "Дом",
      filterStatus: "Статус",
      all: "Все",
      date: "Дата",
      name: "Имя",
      contact: "Контакты",
      buildingCol: "Дом / Квартира",
      status: "Статус",
      source: "Источник",
      actions: "Действия",
      view: "Смотреть",
      noLeads: "Запросов нет",
      leadDetail: "Информация о запросе",
      notes: "Внутренние заметки",
      addNote: "Добавить заметку",
      notePlaceholder: "Напишите заметку (итог звонка, напоминание)...",
      save: "Сохранить",
      message: "Сообщение",
      receivedAt: "Получено",
      updateStatus: "Изменить статус",
      inventoryTitle: "Доступность квартир",
      markAs: "Отметить как",
    },
    statuses: {
      New: "Новый",
      Contacted: "Связались",
      "Viewing Scheduled": "Назначен просмотр",
      Negotiating: "Переговоры",
      Sold: "Продано",
      Lost: "Потеряно",
    },
  },
};
